import { Link } from "react-router-dom";
import { editorPicks } from "@/mocks/articles";

export default function PicksSection() {
  return (
    <section id="picks" className="scroll-mt-24 bg-background-100 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-edit-2-line" />
              编辑精选
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              今日精选好料
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
              主编按信息密度与启发性逐一过目后选出的内容，代表看料最有把握
              「值得一读」的那批，帮你快速锁定今日重点。
            </p>
          </div>
          <Link
            to="/rank"
            className="hidden shrink-0 items-center gap-1 text-sm font-semibold text-primary-700 transition-colors hover:text-primary-900 sm:inline-flex whitespace-nowrap"
          >
            查看完整榜单 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {editorPicks.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex gap-4 rounded-xl border border-background-200/80 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-200 md:gap-5 md:p-4"
            >
              <div className="relative shrink-0 self-start">
                <div className="aspect-[4/3] w-28 overflow-hidden rounded-lg bg-background-200 md:w-40">
                  <img
                    src={article.cover}
                    alt={article.coverAlt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span className="absolute -left-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50 shadow">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-center min-w-0">
                <span className="text-xs font-semibold text-primary-600">{article.categoryName}</span>
                <h3 className="mt-1.5 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {article.title}
                </h3>
                <p className="mt-2 hidden text-sm leading-6 text-foreground-600 lg:line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-2.5 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-pen-nib-line text-accent-500" /> {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" /> {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}